module.exports = __webpack_public_path__ + "static/media/back-arrow.4d00fa32.svg";